/* ============================================================================
   assets/r24-pdp-main.js — ausgelagert aus sections/r24-product-main.liquid (Audit 31.10.2026,
   Vorschlag 11: 60 KB Inline-JS je Produktseite → gecachte Datei).
   Ab jetzt ist DIESE Datei die Quelle der Wahrheit; im Liquid stehen an der alten Stelle
   der Daten-Block [data-r24pd-data] (JSON: Varianten, Medien, Lieferzeit, Routen) und der
   Skript-Tag (Verweis R24-JS-AUSGELAGERT). Code unveraendert — nur die Liquid-Werte kommen
   jetzt aus D. Pruefung: npm run css:check (audit/perf/extract-css.mjs, Abschnitt "scripts").
   ============================================================================ */
/* ── Ankunft oben (Clarity, iPhone, 23.09.2026: Seite stand beim Ankommen schon mitten im
   Kaufbereich, Titel und Preis oben abgeschnitten). Ursache: der Kurz-Link „Auswahl & Kauf“
   schrieb #r24pd-kauf in die Adresse. Jedes spätere Laden dieser Adresse (iOS lädt Tabs aus
   dem Hintergrund neu, geteilte/kopierte Links, Merkliste-Verläufe) sprang dorthin, und der
   feste Kopf deckte den Rest ab. Regeln:
   · Der Link springt weiter weich zur Auswahl, schreibt aber KEINEN Anker mehr.
   · Neuer Besuch (Navigation „navigate“) mit dem eigenen, veralteten #r24pd-kauf: Anker
     entfernen und oben beginnen.
   · Neuer Besuch ohne Anker: steht die Seite bis zum Laden ohne jede Eingabe der Kundin
     unten, zurück nach oben (Sicherheitsnetz gegen jeden automatischen Sprung).
   · Zurück/Vor (bfcache, „back_forward“) und Neuladen behalten die Lage; ein fremder Anker
     (#produktanfrage, Tab-Anker) bleibt ein gewollter Sprung. ── */
(function () {
  var KAUF = '#r24pd-kauf';
  var root = document.querySelector('[data-r24pd]');
  if (!root) return;
  var go = root.querySelector('a[href="' + KAUF + '"]');
  if (go) go.addEventListener('click', function (e) {
    var ziel = document.getElementById('r24pd-kauf');
    if (!ziel) return;
    e.preventDefault();
    var rm = false; try { rm = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (err) { rm = false; }
    ziel.scrollIntoView({ block: 'start', behavior: rm ? 'auto' : 'smooth' });
  });
  var typ = 'navigate';
  try { var n = window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0]; if (n && n.type) typ = n.type; }
  catch (e) { if (window.console) console.warn('[r24pd] Navigationsart unbekannt, gilt als neuer Besuch', e); }
  if (typ !== 'navigate') return;
  var h = location.hash || '';
  if (h === KAUF) {
    try { history.replaceState(history.state, '', location.pathname + location.search); }
    catch (e) { if (window.console) console.warn('[r24pd] Anker konnte nicht entfernt werden', e); }
  } else if (h) return;
  var eingabe = false;
  ['touchstart', 'wheel', 'keydown', 'pointerdown'].forEach(function (t) {
    window.addEventListener(t, function () { eingabe = true; }, { passive: true, capture: true, once: true });
  });
  /* Farbwechsel über die Farbgruppe (assets/r24-farbgruppe.js) behält die Scrollhöhe — dann nicht nach oben. */
  function oben() { if (!eingabe && !window.R24FG_KEEP && (window.pageYOffset || document.documentElement.scrollTop || 0) > 0) window.scrollTo(0, 0); }
  oben();
  window.addEventListener('load', function () { oben(); setTimeout(oben, 300); }, { once: true });
})();

(function () {
  var root = document.querySelector('[data-r24pd]');
  if (!root) return;
  /* Liquid-Werte (Varianten, Medien, Lieferzeit, Routen) stehen als JSON im Block [data-r24pd-data]
     (sections/r24-product-main) — mit Bildschutz ohne Original-Bild-URLs. */
  var D = {};
  try { D = JSON.parse((document.querySelector('[data-r24pd-data]') || {}).textContent || '{}'); }
  catch (e) { if (window.console) console.warn('[r24pd] Produktdaten nicht lesbar:', e); }
  var VARIANTS = D.variants || [];
  var form = root.querySelector('#r24pd-form');
  var idInput = root.querySelector('[data-variant-id]');
  var stage = root.querySelector('[data-stage]');

  /* Buehnenbild IMMER hierueber tauschen: `src` und `srcset` muessen zusammen
     wechseln. Setzt man nur `src`, gewinnt das alte `srcset` und das Bild
     bleibt stehen — der Farbwechsel sieht dann wirkungslos aus. */
  /* Galerie schnell (Owner 23.09.2026: „Blättern ist schwer und langsam“): vorher wurde je
     Klick ein NEUES Bild geladen — vorgewärmt war width=1000, die Bühne wählte über srcset
     aber 1200 (Retina/Handy) → der Vorrat traf nie. Jetzt EINE Breite je Gerät (stageW) für
     Bühne UND Vorwärmen; getauscht wird erst, wenn das Bild geladen ist (kein Hängen auf dem
     alten Bild, kein weißes Blitzen); nur die Nachbarn werden vorgewärmt, nicht alle Bilder. */
  function stageW(){
    var w = ((stage && stage.clientWidth) || 620) * (window.devicePixelRatio || 1);
    return w <= 600 ? 600 : (w <= 900 ? 900 : 1200);
  }
  function stageUrl(url){
    if(!url) return url;
    return /[?&]width=\d+/.test(url) ? url.replace(/([?&])width=\d+/, '$1width=' + stageW()) : url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + stageW();
  }
  var _stageReq = 0;
  /* Buehnenbild IMMER hierueber tauschen: `srcset` wird dabei entfernt — sonst gewinnt das
     alte `srcset` aus dem Server-Markup und das Bild bleibt stehen. */
  function stageSet(url){
    if(!stage || !url) return;
    var big = stageUrl(url), req = ++_stageReq, box = stage.parentNode;
    function swap(){
      if(req !== _stageReq) return;
      stage.removeAttribute('srcset'); stage.removeAttribute('sizes');
      stage.src = big; if(box) box.classList.remove('is-loading');
    }
    var im = preload(big);
    if(!im || !im.addEventListener || (im.complete && im.naturalWidth)){ swap(); return; }
    if(box) box.classList.add('is-loading');
    im.addEventListener('load', swap, { once: true });
    im.addEventListener('error', swap, { once: true });
  }
  var mediaSrc = D.mediaSrc || [];
  var media = D.media || mediaSrc.map(function(m){ return m.preview_image; });
  /* Auswahl-Zustand generisch je Options-Position (1..3) — deckt Farbe, Maße,
     Türanschlag und jede künftige Option ab, statt nur color/size. */
  var sel = D.sel || {};
  var colorPos = D.colorPos || 0;
  /* Owner 01.10.2026 (K73-G400 mit Hochschrank-Wahl): Bildsatz je Option auch ohne Farb-Option — die erste Option,
     deren Werte auf VERSCHIEDENE Variantenbilder zeigen (Blockanfang je Wert), steuert die Galerie wie eine Farbe.
     Swatches bleiben nur für Farb-Optionen. */
  var mediaPos = colorPos || (function(){ for(var i=1;i<=3;i++){ var at={}, ps={}, n=0, ok=true;
      VARIANTS.forEach(function(v){ var o=v['option'+i], fm=v.featured_media; if(o==null||!fm||!fm.position) return; if(at[o]==null){ at[o]=fm.position; n++; if(ps[fm.position]) ok=false; ps[fm.position]=1; } });
      if(n>1&&ok) return i; } return 0; })();
  /* Lieferzeit je Variante (snippets/r24-lieferzeit: Variante > Produkt > keine Dauer).
     In LZ stehen NUR Varianten mit eigener Angabe; alle anderen zeigen die Produkt-
     angabe LZ0 — [Satz fuer die Kaufbox, Dauer fuer den Versand-Tab, Tage „Start-Ende“
     fuer das Lieferfenster]. */
  var LZ0 = D.lz0 || ['', '', ''];
  /* Auch bei EINER Variante: traegt nur sie die Lieferzeit, ueberschriebe render()
     sonst die Server-Angabe mit „auf Anfrage“ (Review R5). */
  var LZ = D.lz || {};
  /* ---- Lieferfenster „Voraussichtliche Lieferung: Mi., 8. Okt. – Fr., 17. Okt.“ (Runde 3).
     Quelle: dieselben Tage wie die Wochen-Angabe (snippets/r24-lieferzeit, Format 'tage',
     Variante > Produkt). Zaehlweise wie dort und im Kalles-Format der Metafelder: Tage ab
     HEUTE in Europe/Berlin; faellt ein Datum auf Sa/So, gilt der folgende Montag (Zustellung
     nur Mo–Fr). Mindestens 1 Tag, Ende nie vor dem Start. Ohne Angabe: nichts. Kein
     Bestellschluss, keine Uhrzeit — nur „voraussichtlich“. ---- */
  var ETA_TAG = ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'];
  var ETA_MON = ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sept.', 'Okt.', 'Nov.', 'Dez.'];
  function heuteBerlin(jetzt) {
    try {
      var t = {};
      new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Berlin', year: 'numeric', month: 'numeric', day: 'numeric' })
        .formatToParts(jetzt).forEach(function (x) { t[x.type] = +x.value; });
      if (t.year && t.month && t.day) return Date.UTC(t.year, t.month - 1, t.day);
    } catch (e) { if (window.console) console.warn('[r24pd] Zeitzone Europe/Berlin nicht verfuegbar, Geraetezeit als Rueckfall:', e); }
    return Date.UTC(jetzt.getFullYear(), jetzt.getMonth(), jetzt.getDate());
  }
  function werktag(ms) { var d = new Date(ms).getUTCDay(); return d === 6 ? ms + 2 * 864e5 : d === 0 ? ms + 864e5 : ms; }
  function etaDatum(ms) { var d = new Date(ms); return ETA_TAG[d.getUTCDay()] + ', ' + d.getUTCDate() + '. ' + ETA_MON[d.getUTCMonth()]; }
  function lieferfenster(tage, jetzt) {
    var m = /^(\d+)-(\d+)$/.exec(String(tage || ''));
    if (!m) return '';
    var s = Math.max(1, +m[1]), e = Math.max(s, +m[2]), h = heuteBerlin(jetzt || new Date());
    var a = werktag(h + s * 864e5), b = werktag(h + e * 864e5);
    return a === b ? etaDatum(a) : etaDatum(a) + ' – ' + etaDatum(b);
  }
  function zeigeFenster(tage) {
    var box = root.querySelector('[data-stock]'), eta = root.querySelector('[data-r24-eta]');
    if (!eta) return;
    var f = lieferfenster(tage);
    eta.hidden = !f;
    setText(eta.querySelector('[data-r24-eta-v]'), f);
    if (box) box.classList.toggle('has-eta', !!f);
  }

  /* ---- Farb-Galerie: pro Farbe ALLE zugehörigen Bilder zeigen (Media-Block ab dem
     featured_media der Farbe bis zur nächsten Farbe), statt nur EIN Bild. Bilder sind
     in Positions-Blöcken je Farbe abgelegt; jede Farbvariante zeigt auf den Blockanfang. ---- */
  var COLORMEDIA = (function(){
    if(!mediaPos) return null;
    var starts=[], seen={};
    VARIANTS.forEach(function(v){ var c=v['option'+mediaPos], fm=v.featured_media;
      if(c && fm && fm.position && !seen[c]){ seen[c]=1; starts.push({c:c,pos:fm.position}); } });
    if(!starts.length) return null;
    starts.sort(function(a,b){ return a.pos-b.pos; });
    var map={};
    starts.forEach(function(s,i){ var next=(i+1<starts.length)?starts[i+1].pos:1e9;
      map[s.c]=mediaSrc.filter(function(m){ return m.position>=s.pos && m.position<next; }); });
    return map;
  })();
  function _mSrc(m){ return ((m.preview_image && m.preview_image.src) || m.src || '').split('?')[0]; }
  function showColorGallery(color, keepStage){
    var wrap = root.querySelector('[data-thumbs]');
    if(!COLORMEDIA || !wrap) return false;
    var list = COLORMEDIA[color];
    if(!list || !list.length) return false;
    /* Kacheln als echte DOM-Knoten bauen statt als HTML-Zeichenkette: die Bild-URL
       landet dann als Eigenschaft im Element und kann das Attribut nicht verlassen
       (kein Ausbruch aus src="…"). Gleichzeitig geht der Alternativtext nicht mehr
       verloren, den die serverseitig gerenderten Kacheln tragen. */
    var frag = document.createDocumentFragment();
    list.forEach(function(m,i){
      var b = _mSrc(m);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'r24pd-thumb' + (i === 0 ? ' is-active' : '');
      btn.setAttribute('data-thumb', String(i));
      btn.setAttribute('aria-label', 'Bild ' + (i + 1));
      if (i === 0) btn.setAttribute('aria-current', 'true');
      var im = document.createElement('img');
      im.src = b + '?width=160';
      im.alt = (m.alt || '');
      im.loading = 'lazy'; im.width = 74; im.height = 74;
      btn.appendChild(im);
      btn.addEventListener('click', function(){ selectThumb(+btn.getAttribute('data-thumb')); });
      frag.appendChild(btn);
    });
    wrap.replaceChildren ? wrap.replaceChildren(frag) : (wrap.innerHTML = '', wrap.appendChild(frag));
    if(!keepStage && stage && list[0]){ stageSet(_mSrc(list[0]) + '?width=1000'); stage.removeAttribute('hidden'); }
    warmSet(list.slice(0, 3).map(function(m){ return stageUrl(_mSrc(m)); }));
    _galColor = color;
    return true;
  }
  /* _galColor = Farbe, deren Satz der Kachelstreifen GERADE zeigt (null = Server-Kacheln,
     alle Bilder). Die Vollbild-Galerie folgt dem Streifen, nicht der Variante. */
  var _lastColor = null, _galColor = null;
  function syncGallery(v){ if(!mediaPos || !v) return; var c=v['option'+mediaPos]; if(c===_lastColor) return; _lastColor=c; showColorGallery(c, true); }

  function money(cents){ try{ return (cents/100).toLocaleString('de-DE',{minimumFractionDigits:2,maximumFractionDigits:2})+' €'; }catch(e){ return (cents/100).toFixed(2)+' €'; } }
  /* Nur schreiben, wenn sich der Text ändert — Preiszeilen sind Live-Bereiche und
     würden sonst beim Start ohne Änderung vorgelesen. */
  function setText(el, s){ if (el && el.textContent !== s) el.textContent = s; }
  /* Rabatt in ganzen Prozent, ABGERUNDET — wie der Server (ganzzahlige Division) und jede
     Karte im Shop. Vorher Math.round: 33,7 % wurden beim Variantenwechsel zu „−34 %“,
     obwohl die Seite mit „−33 %“ kam. Erst multiplizieren, dann teilen (Cent bleiben
     ganzzahlig; 0,29 * 100 ergaebe 28,999…). */
  function pctOff(was, now){ return Math.floor((was - now) * 100 / was); }
  /* Auswahlzustand für Vorleser: die Klasse is-active allein sagt ihnen nichts.
     Farbe/Option = aria-pressed, Miniatur = aria-current. */
  function mark(el, on){
    el.classList.toggle('is-active', on);
    if (el.hasAttribute('data-thumb')) { if (on) el.setAttribute('aria-current', 'true'); else el.removeAttribute('aria-current'); }
    else el.setAttribute('aria-pressed', on ? 'true' : 'false');
  }
  var RM = false; try { RM = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  function currentVariant(){
    return VARIANTS.find(function(v){
      return Object.keys(sel).every(function(pos){ return v['option'+pos] === sel[pos]; });
    });
  }

  /* Zustand des echten Kaufknopfs an EINER Stelle: ok · aus (ausverkauft) · na (diese
     Kombination gibt es nicht) · busy (Anfrage läuft). Er steht in data-state; die
     Kaufleiste liest ihn nach dem Ereignis „r24pd:state“ und spiegelt ihn — kein
     zweiter Zustand, und während einer Anfrage kann niemand ein zweites Mal absenden. */
  var busy = false, leaving = false, lastV = null;
  function atcState(){
    var atc = root.querySelector('[data-atc]'), atcl = root.querySelector('[data-atc-label]');
    if (!atc) return;
    var st = busy ? 'busy' : !lastV ? 'na' : lastV.available ? 'ok' : 'aus';
    if (st === 'ok') atc.removeAttribute('disabled'); else atc.setAttribute('disabled', 'disabled');
    if (st === 'busy') atc.setAttribute('aria-busy', 'true'); else atc.removeAttribute('aria-busy');
    if (st !== 'busy') setText(atcl, st === 'ok' ? 'In den Warenkorb' : st === 'aus' ? 'Ausverkauft' : 'Nicht verfügbar');
    atc.setAttribute('data-state', st);
    root.dispatchEvent(new CustomEvent('r24pd:state'));
  }

  /* user = true nur nach einer Auswahl der Kundin (Klick auf Farbe/Option); der Start-
     Aufruf beim Laden setzt Preis, Verfügbarkeit und Knöpfe, lässt aber die Galerie. */
  /* Owner 01.10.2026: Varianten mit EIGENER Teileliste (r24_set.components an der Variante, z. B. Hochschrank Vorrat ↔
     Kühlschrank) — Set-Teile, Lieferumfang und Konfigurator sind serverseitig gerendert. Wechselt die Kundin zu einer Variante
     mit anderer Teileliste, lädt die Seite mit ?variant= neu (Scroll-Position bleibt). */
  var SETV = D.setv || {};
  function setKey(v){ return v && SETV[v.id] ? String(v.id) : 'p'; }
  var SETK0 = setKey(VARIANTS.find(function(x){ return x.id === (D.cv || 0); }));
  var SETRL = false;   /* true = Seite kam vom Wechsel auf eine Variante mit eigener Teileliste → Bildsatz dieser Variante zeigen */
  try { var _sy = sessionStorage.getItem('r24pdSetY'); if (_sy) { sessionStorage.removeItem('r24pdSetY'); SETRL = true; window.scrollTo(0, +_sy || 0); } } catch (e) {}
  function render(user){
    var v = currentVariant();
    if (user && v && Object.keys(SETV).length && setKey(v) !== SETK0) {
      try { sessionStorage.setItem('r24pdSetY', String(window.scrollY || 0)); } catch (e) {}
      var _u = new URL(location.href); _u.searchParams.set('variant', v.id); location.replace(_u.toString()); return;
    }
    lastV = v || null;
    atcMsg('');
    /* Auswahl-Beschriftungen folgen der AUSWAHL (sel), nicht einer Ersatz-Variante. */
    var cl = root.querySelector('[data-color-label]'); if (cl && colorPos) setText(cl, sel[colorPos]);
    root.querySelectorAll('[data-opt-label]').forEach(function(el){
      var p = el.getAttribute('data-opt-label'); if (p && sel[p]) setText(el, sel[p]);
    });
    if (!v) {
      /* Diese Kombination gibt es nicht (Varianten-Matrix mit Lücken). Vorher sprang
         die Auswahl still auf VARIANTS[0]: in den Warenkorb kam eine ANDERE Variante
         als angezeigt — bei Arbeitsplatten ein anderer Längenbereich als die
         eingegebene Zuschnitt-Länge. Jetzt: keine Varianten-ID, Knopf gesperrt,
         klare Angabe in Kaufbox und Kurz-Preiszeile. */
      if (idInput) idInput.value = '';
      var qs0 = root.querySelector('[data-quick-stock]');
      if (qs0) { setText(qs0, 'Nicht verfügbar'); qs0.classList.toggle('is-out', true); }
      setText(root.querySelector('[data-stock-h]'), 'Nicht verfügbar');
      var st0 = root.querySelector('[data-stock]'); if (st0) st0.classList.add('is-out');
      /* Runde 3 (Review R5 L3): KEIN Preis, Streichpreis, Rabatt oder Art.-Nr. der zuletzt
         gewaehlten Variante — sie gehoeren zu einer Kombination, die nicht angezeigt wird.
         „—“ auch in der Kaufleiste (liest [data-now]); die PayPal-Botschaft blendet sich
         ohne Betrag aus. Das Lieferfenster entfaellt ebenso. */
      setText(root.querySelector('[data-now]'), '—');
      var pr0 = root.querySelector('[data-price]'); if (pr0) pr0.classList.add('is-na');
      setText(root.querySelector('[data-quick-now]'), '—');
      var qw0 = root.querySelector('[data-quick-was]'), qo0 = root.querySelector('[data-quick-off]');
      if (qw0) qw0.hidden = true; if (qo0) qo0.hidden = true;
      setText(root.querySelector('[data-sku]'), '—');
      setText(root.querySelector('[data-quick-var]'), Object.keys(sel).sort().map(function (k) { return sel[k]; }).join(' / '));
      zeigeFenster('');
      atcState();
      return;
    }
    if (idInput) idInput.value = v.id;
    setText(root.querySelector('[data-now]'), money(v.price));
    var price = root.querySelector('[data-price]');
    if (price) price.classList.remove('is-na');
    var was = root.querySelector('[data-was]'), off = root.querySelector('[data-off]');
    if (v.compare_at_price && v.compare_at_price > v.price) {
      var pct = pctOff(v.compare_at_price, v.price);
      if (!was) { was = document.createElement('span'); was.className='was'; was.setAttribute('data-was','');
        was.innerHTML = '<span class="r24pd-vh">statt </span><span data-was-v></span>'; price.appendChild(was); }
      if (!off) { off = document.createElement('span'); off.className='off'; off.setAttribute('data-off',''); price.appendChild(off); }
      setText(was.querySelector('[data-was-v]') || was, money(v.compare_at_price)); was.style.display=''; setText(off, '−'+pct+'%'); off.style.display='';
    } else { if (was) was.style.display='none'; if (off) off.style.display='none'; }
    var sku = root.querySelector('[data-sku]'); if (sku) setText(sku, v.sku || '—');
    /* Versandzeile (snippets/r24-versandzeile) folgt dem Variantenpreis — nur Anzeige;
       beide Sätze stehen im Markup, hier wird nur der passende eingeblendet. */
    root.querySelectorAll('[data-ship-ab]').forEach(function(el){
      var frei = v.price >= +el.getAttribute('data-ship-ab');
      var f = el.querySelector('[data-ship="frei"]'), z = el.querySelector('[data-ship="zzgl"]');
      if (f) f.hidden = !frei; if (z) z.hidden = frei;
      // Karte: „noch … bis versandkostenfrei“ folgt dem Variantenpreis.
      var rv = el.querySelector('[data-ship-rest-v]');
      if (rv) setText(rv, money(Math.max(0, +el.getAttribute('data-ship-ab') - v.price)));
    });
    /* Kurz-Preiszeile (Telefon) und Verfügbarkeitskarte folgen der Variante — vorher
       stand „Auf Lager“ auch bei einer ausverkauften Variante. */
    var sale = !!(v.compare_at_price && v.compare_at_price > v.price);
    setText(root.querySelector('[data-quick-now]'), money(v.price));
    var qw = root.querySelector('[data-quick-was]'), qo = root.querySelector('[data-quick-off]');
    if (qw) { qw.hidden = !sale; if (sale) setText(qw.querySelector('[data-quick-was-v]'), money(v.compare_at_price)); }
    if (qo) { qo.hidden = !sale; if (sale) setText(qo, '−' + pctOff(v.compare_at_price, v.price) + '%'); }
    var qs = root.querySelector('[data-quick-stock]');
    if (qs) { setText(qs, v.available ? 'Auf Lager' : 'Ausverkauft'); qs.classList.toggle('is-out', !v.available); }
    var qv = root.querySelector('[data-quick-var]'); if (qv && v.title) setText(qv, v.title);
    setText(root.querySelector('[data-stock-h]'), v.available ? 'Auf Lager' : 'Ausverkauft');
    var stk = root.querySelector('[data-stock]'); if (stk) stk.classList.toggle('is-out', !v.available);
    /* Lieferzeit folgt der Variante: Kaufbox (Satz + Lieferfenster) und Versand-Tab (Dauer). */
    var lz = LZ[v.id] || LZ0;
    [].forEach.call(document.querySelectorAll('[data-r24-lz]'), function(el){
      if (el.getAttribute('data-r24-lz') === 'dauer') { el.hidden = !lz[1]; setText(el.querySelector('[data-r24-lz-v]'), lz[1]); }
      else setText(el, lz[0]);
    });
    zeigeFenster(v.available ? lz[2] : '');
    if (window.R24Wis) { var _on = window.R24Wis.has(String(v.id)); var _m = root.querySelector('[data-merken]'), _w = root.querySelector('[data-wish]');
      if (_m) { _m.classList.toggle('is-on', _on); _m.setAttribute('aria-pressed', _on ? 'true' : 'false'); var _s = _m.querySelector('span'); if (_s) _s.textContent = _on ? 'Gemerkt' : 'Merken'; }
      if (_w) { _w.classList.toggle('is-on', _on); _w.setAttribute('aria-pressed', _on ? 'true' : 'false'); } }
    /* Bild der Variante — NUR, wenn die Kundin selbst eine Variante gewählt hat (user)
       und diese Variante ein EIGENES Bild trägt. Beim Laden bleibt die Bühne auf dem
       ersten Produktbild (Raumbild), auch mit ?variant= aus Google Shopping: vorher
       sprang die Seite dort auf das Variantenbild — bei Küchen eine Front-Nahaufnahme
       („17 / 20“ gemessen live 23.09.2026) statt der ganzen Küche. */
    var vfi = v.featured_image, vfm = v.featured_media;
    var vsrc = (vfi && vfi.src) || (vfm && vfm.preview_image && vfm.preview_image.src) || '';
    if (user) {
      if (vsrc && stage) {
        stageSet(vsrc + (vsrc.indexOf('?') > -1 ? '&' : '?') + 'width=1000');
        stage.removeAttribute('hidden');
      }
      /* Bei Farbwechsel die komplette Bild-Galerie dieser Farbe zeigen (nicht nur ein Bild). */
      syncGallery(v);
      /* Passende Miniatur hervorheben, wenn das Variantenbild unter den gezeigten liegt
         (Vergleich über den Dateinamen — Bühne und Kacheln bauen die URL verschieden). */
      if (vsrc) {
        var vname = _fname(vsrc), hit = -1, th = root.querySelectorAll('[data-thumb]');
        th.forEach(function(t){ var im = t.querySelector('img'); if (hit < 0 && im && _fname(im.getAttribute('src')) === vname) hit = +t.getAttribute('data-thumb'); });
        if (hit > -1) th.forEach(function(t){ mark(t, +t.getAttribute('data-thumb') === hit); });
      }
    }
    atcState();
  }
  function _fname(u){ return String(u || '').split('?')[0].split('/').pop(); }

  function selectThumb(i){
    var thumbs = root.querySelectorAll('[data-thumb]');
    if (!thumbs.length || i < 0 || i >= thumbs.length) return;
    thumbs.forEach(function(t){ mark(t, +t.getAttribute('data-thumb') === i); });
    var img = thumbs[i].querySelector('img');
    if (img && stage) { stageSet(img.src);
      /* Nachbar-Bilder (in Bühnenbreite) vorab laden → nächster Klick/Wisch ist sofort. */
      var n = thumbs.length;
      [i + 1, i - 1, i + 2].forEach(function (j) { j = (j + n) % n; var im2 = thumbs[j] && thumbs[j].querySelector('img');
        if (im2) preload(stageUrl(im2.src)); }); }
    /* Nur den Kachelstreifen verschieben — scrollIntoView bewegte auf Telefonen die ganze Seite. */
    try { var strip = thumbs[i].parentNode, r = thumbs[i].getBoundingClientRect(), sr = strip.getBoundingClientRect();
      if (strip.scrollBy) strip.scrollBy({ left: (r.left - sr.left) - (sr.width - r.width) / 2, top: (r.top - sr.top) - (sr.height - r.height) / 2, behavior: RM ? 'auto' : 'smooth' }); } catch(e) {}
  }

  root.querySelectorAll('[data-thumb]').forEach(function(t){
    t.addEventListener('click', function(){ selectThumb(+t.getAttribute('data-thumb')); });
  });

  /* Wischen auf der großen Bühne → vorheriges/nächstes Bild (mobile Galerie-Navigation). */
  (function(){
    var st = root.querySelector('.r24pd-stage'); if(!st) return;
    function count(){ return root.querySelectorAll('[data-thumb]').length; }
    function curIdx(){ var a = root.querySelector('[data-thumb].is-active'); return a ? +a.getAttribute('data-thumb') : 0; }
    function go(dir){ var n = count(); if(n < 2) return; selectThumb((curIdx() + dir + n) % n); }
    var x0=null, y0=null;
    st.addEventListener('touchstart', function(e){ var t=e.changedTouches[0]; x0=t.clientX; y0=t.clientY; }, {passive:true});
    st.addEventListener('touchend', function(e){ if(x0===null) return; var t=e.changedTouches[0], dx=t.clientX-x0, dy=t.clientY-y0; x0=null;
      if(Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)*1.3){ go(dx < 0 ? 1 : -1); } }, {passive:true});
  })();

  /* Start-Galerie: die Seite beginnt IMMER beim ersten Produktbild (Bühne = featured_media,
     Server). Den Farbsatz der vorgewählten Farbe zeigen wir nur, wenn er mit genau diesem
     ersten Bild beginnt — sonst bleiben die Server-Kacheln (alle Bilder, erstes aktiv) und der
     Farbsatz folgt erst dem ersten Farbwechsel der Kundin. Vorher ersetzte der Start den
     Streifen durch den Satz der ?variant=-Farbe, und die Bühne sprang auf dessen Bild. */
  if (mediaPos) {
    var v0 = currentVariant() || VARIANTS[0], c0 = v0 && v0['option'+mediaPos], l0 = COLORMEDIA && c0 ? COLORMEDIA[c0] : null;
    if (l0 && l0.length && l0[0].position === 1) syncGallery(v0);
    else if (l0 && l0.length && SETRL) { _lastColor = c0; showColorGallery(c0, false); }
  }

  root.querySelectorAll('.r24pd-swatches [data-opt]').forEach(function(b){
    b.addEventListener('click', function(){
      if (colorPos) sel[colorPos] = b.getAttribute('data-opt');
      root.querySelectorAll('.r24pd-swatches [data-opt]').forEach(function(x){ mark(x, x===b); });
      render(true);
    });
  });
  /* Jede generische Options-Gruppe (Maße, Türanschlag, …) — Auswahl je eigener Position. */
  root.querySelectorAll('.r24pd-sizes[data-optpos]').forEach(function(grp){
    var pos = grp.getAttribute('data-optpos');
    grp.querySelectorAll('[data-opt]').forEach(function(b){
      b.addEventListener('click', function(){
        sel[pos] = b.getAttribute('data-opt');
        grp.querySelectorAll('[data-opt]').forEach(function(x){ mark(x, x===b); });
        render(true);
      });
    });
  });

  var qi = root.querySelector('[data-qty]');
  root.querySelector('[data-qtm]').addEventListener('click', function(){ qi.value = Math.max(1, (parseInt(qi.value,10)||1) - 1); });
  root.querySelector('[data-qtp]').addEventListener('click', function(){ qi.value = (parseInt(qi.value,10)||1) + 1; });

  /* Fehlermeldung zum Hinzufügen: steht dauerhaft unter der Kaufzeile (role=alert →
     wird vorgelesen) statt 2,6 s im gesperrten Knopf. Liegt sie außerhalb des Bildes
     (Klick kam aus der Kaufleiste), wird sie einmal ins Bild geholt. */
  var atcMsgEl = root.querySelector('[data-atc-msg]');
  function atcMsg(t){
    if (!atcMsgEl) return;
    setText(atcMsgEl, t);
    if (!t) return;
    var r = atcMsgEl.getBoundingClientRect();
    if (r.top < 0 || r.bottom > window.innerHeight) { try { atcMsgEl.scrollIntoView({ block:'center', behavior: RM ? 'auto' : 'smooth' }); } catch(e) {} }
  }

  /* Add-to-cart über AJAX + Kalles-Drawer öffnen.
     Doppel-Absenden: busy sperrt Knopf UND Kaufleiste (atcState), bis die Antwort da
     ist; nach Erfolg bleibt die Sperre bis zur Weiterleitung stehen (leaving), sonst
     ging in der Lücke vor dem Seitenwechsel ein zweites Hinzufügen durch. */
  if (form) form.addEventListener('submit', function(e){
    e.preventDefault();
    var atc = root.querySelector('[data-atc]');
    if (busy || atc.hasAttribute('disabled') || !idInput || !idInput.value) return;
    var body = new FormData(form);
    busy = true; atcState();
    atcMsg('');
    fetch('/cart/add.js', { method:'POST', headers:{'Accept':'application/json'}, body: body })
      /* Antwort ohne JSON (z. B. 429-Seite) ist KEIN Netzfehler — Status behalten. */
      .then(function(r){ return r.json().then(function(j){ return { ok: r.ok, data: j, status: r.status }; },
                                             function(){ return { ok: r.ok, data: null, status: r.status }; }); })
      .then(function(res){
        /* Fehlgeschlagenes Hinzufügen (ausverkauft, Limit, Überlast): NICHT umleiten,
           sondern den Grund dauerhaft zeigen — vorher schlug es still fehl. */
        if (!res.ok) {
          var d = res.data && (res.data.description || res.data.message);
          /* Nie einen Statuscode zeigen — gleiche Worte wie der Warenkorb (FAIL in r24-cart). */
          atcMsg(d ? String(d) : (res.status === 429 ? 'Der Shop ist gerade ausgelastet. Bitte in ein paar Sekunden erneut versuchen.'
            : res.status >= 500 ? 'Der Shop antwortet gerade nicht. Bitte gleich noch einmal versuchen.'
            : 'Der Artikel konnte nicht in den Warenkorb gelegt werden. Bitte erneut versuchen.'));
          return;
        }
        ['cart:refresh','on:cart:add','cart:updated'].forEach(function(ev){ try{ document.dispatchEvent(new CustomEvent(ev,{bubbles:true})); }catch(e){} });
        leaving = true;
        /* Aufbauservice (snippets/r24-aufbau): „Aufbau mitbestellen“ angehakt → Service-Zeile
           zum Möbel legen, DANN weiterleiten. Fehler dort halten den Kauf nie auf. */
        var ab = null; try { ab = window.R24Aufbau && window.R24Aufbau.onAdded ? window.R24Aufbau.onAdded(idInput.value, parseInt(body.get('quantity'), 10) || 1) : null; } catch (e) { ab = null; }
        Promise.resolve(ab).then(function(){ window.location.assign(D.cart || '/cart'); }, function(){ window.location.assign(D.cart || '/cart'); });
        /* Direkt zur Warenkorbseite (Owner-Wunsch) — ohne zweiten /cart.js-Roundtrip. */
      })
      .catch(function(){ atcMsg('Keine Verbindung zum Shop – der Artikel wurde nicht in den Warenkorb gelegt. Bitte Verbindung prüfen und erneut versuchen.'); })
      .then(function(){ if (!leaving) { busy = false; atcState(); } });
  });
  /* Zurück aus dem Warenkorb (Seite aus dem bfcache): die Sperre von vorhin lösen. */
  window.addEventListener('pageshow', function(e){ if (e.persisted && busy) { busy = false; leaving = false; atcState(); } });

  /* Merkliste an R24Wis (falls vorhanden) */
  var wish = root.querySelector('[data-wish]');
  if (wish) wish.addEventListener('click', function(){
    if (!window.R24Wis) return;
    var v = currentVariant() || VARIANTS[0];
    var entry = { v:String(v.id), p:String(D.pid), h:D.handle, t:D.title,
      opt:(v.title||''), img:(stage?stage.src:''), price:money(v.price), url:D.url+'?variant='+v.id };
    var won = window.R24Wis.toggle(entry);
    wish.classList.toggle('is-on', won); wish.setAttribute('aria-pressed', won ? 'true' : 'false');
  });

  var merk = root.querySelector('[data-merken]');
  if (merk) merk.addEventListener('click', function(){
    if (!window.R24Wis) return;
    var v = currentVariant() || VARIANTS[0];
    var entry = { v:String(v.id), p:String(D.pid), h:D.handle, t:D.title,
      opt:(v.title||''), img:(stage?stage.src:''), price:money(v.price), url:D.url+'?variant='+v.id };
    var on = window.R24Wis.toggle(entry);
    merk.classList.toggle('is-on', on); merk.setAttribute('aria-pressed', on ? 'true' : 'false');
    var sp = merk.querySelector('span'); if (sp) sp.textContent = on ? 'Gemerkt' : 'Merken';
    if (wish) { wish.classList.toggle('is-on', on); wish.setAttribute('aria-pressed', on ? 'true' : 'false'); }
  });

  /* „Frage zum Produkt" → dieselbe Anfrage-Fenster-Quelle wie Quick-View (r24-qv-inquiry) */
  var inqBtn = root.querySelector('[data-inq]');
  if (inqBtn) inqBtn.addEventListener('click', function(){
    var v = currentVariant() || VARIANTS[0];
    var d = { title: D.title, url: location.href,
      price: v ? money(v.price) : '', sku: (v && v.sku) ? v.sku : '', img: stage ? stage.src : '' };
    if (window.R24Inq && window.R24Inq.open) { window.R24Inq.open(d); }
    else { location.href = '/pages/kontakt-royal24_markt?produkt=' + encodeURIComponent(d.title); }
  });

  /* „Teilen" → sauberes Teilen-Fenster (WhatsApp · E-Mail · Facebook · Telegram · Link kopieren) */
  var share = root.querySelector('[data-share]');
  var shareModal = root.querySelector('[data-share-modal]');
  /* Dialog-Fokus (Teilen + Vollbild-Galerie): beim Öffnen auf „Schließen“, Tab bleibt
     im Dialog (Umlauf), beim Schließen zurück zum auslösenden Knopf. Vorher blieb der
     Fokus hinter der Abdeckung auf der Seite. */
  function dialogFocus(dlg, first){
    var back = document.activeElement;
    function onKey(e){
      if (e.key !== 'Tab') return;
      var f = [].filter.call(dlg.querySelectorAll('a[href],button:not([disabled]),[tabindex]:not([tabindex="-1"])'),
        function(x){ return x.offsetWidth > 0 || x.offsetHeight > 0; });
      if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === a || !dlg.contains(document.activeElement))) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && (document.activeElement === z || !dlg.contains(document.activeElement))) { e.preventDefault(); a.focus(); }
    }
    document.addEventListener('keydown', onKey);
    if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
    return function(){
      document.removeEventListener('keydown', onKey);
      if (back && back.focus && document.contains(back)) { try { back.focus({ preventScroll: true }); } catch (e) { back.focus(); } }
    };
  }
  var shareRelease = null, lbRelease = null;
  function shareOpen(){
    var url = location.href, title = D.title;
    if (navigator.share && matchMedia('(max-width:767px)').matches) { navigator.share({ title: title, url: url }).catch(function(){}); return; }
    if (!shareModal) return;
    var U = encodeURIComponent(url), T = encodeURIComponent(title);
    var wa = shareModal.querySelector('[data-share-wa]'); if (wa) wa.href = 'https://wa.me/?text=' + T + '%20' + U;
    var ml = shareModal.querySelector('[data-share-mail]'); if (ml) ml.href = 'mailto:?subject=' + T + '&body=' + T + '%0A' + U;
    var fb = shareModal.querySelector('[data-share-fb]'); if (fb) fb.href = 'https://www.facebook.com/sharer/sharer.php?u=' + U;
    var tg = shareModal.querySelector('[data-share-tg]'); if (tg) tg.href = 'https://t.me/share/url?url=' + U + '&text=' + T;
    shareModal.hidden = false; document.documentElement.style.overflow = 'hidden';
    if (!shareRelease) shareRelease = dialogFocus(shareModal, shareModal.querySelector('[data-share-close]'));
  }
  function shareClose(){ if (shareModal){ shareModal.hidden = true; document.documentElement.style.overflow = '';
    if (shareRelease) { shareRelease(); shareRelease = null; } } }
  if (share) share.addEventListener('click', shareOpen);
  if (shareModal){
    shareModal.addEventListener('click', function(e){ if (e.target === shareModal || e.target.closest('[data-share-close]')) shareClose(); });
    var cp = shareModal.querySelector('[data-share-copy]');
    if (cp) cp.addEventListener('click', function(){
      var sp = cp.querySelector('span'), o = sp ? sp.textContent : '';
      if (navigator.clipboard) navigator.clipboard.writeText(location.href).then(function(){ if (sp){ sp.textContent = 'Link kopiert ✓'; setTimeout(function(){ sp.textContent = o; }, 1500); } });
    });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !shareModal.hidden) shareClose(); });
  }

  /* Vollbild-Lightbox mit Navigation */
  var GAL_ALL = D.gal || [];
  /* Lightbox nur mit den Bildern der AKTUELLEN Farbe (sonst öffnet Zoom ein Bild einer anderen Farbe). */
  function buildLbGal(){
    if(mediaPos && COLORMEDIA){ var c=_galColor; var list=c?COLORMEDIA[c]:null;
      if(list&&list.length){ return list.map(function(m){ return _mSrc(m)+'?width=1600'; }); } }
    return GAL_ALL;
  }
  var GAL = GAL_ALL;
  var lb = root.querySelector('[data-lb]'), lbImg = root.querySelector('[data-lb-img]'), lbCount = root.querySelector('[data-lb-count]');
  var lbStage = root.querySelector('.r24pd-lb__stage');
  var lbIdx = 0;
  /* Nachbar-Bilder vorab laden → Blättern ist sofort (kein Netzwerk-Warten pro Klick). */
  var _pre = _pre || {};
  function preload(src){ if(!src) return null; _pre = _pre || {}; if(_pre[src]) return _pre[src]; var im=new Image(); im.decoding='async'; im.src=src; _pre[src]=im; return im; }
  /* Ganzen aktuellen Bildsatz vorwärmen (idle) → JEDER Klick sofort. Shopify-CDN
     erzeugt jede neue Breite EINMALIG (~700ms, „cold"), danach 0ms („warm"). */
  function warmSet(urls){ if(!urls||!urls.length)return; var run=function(){ urls.forEach(preload); };
    if(window.requestIdleCallback) requestIdleCallback(run,{timeout:1500}); else setTimeout(run,500); }
  var lbErr = root.querySelector('[data-lb-err]');
  /* Lade- UND Fehlerzustand: ohne den error-Zweig blieb der Ladekreis bei einem
     nicht erreichbaren Bild für immer stehen, ohne dass jemand erfuhr warum. */
  if(lbImg){
    lbImg.addEventListener('load', function(){
      if(lbStage) lbStage.classList.remove('is-loading');
      if(lbErr) lbErr.hidden = true;
    });
    lbImg.addEventListener('error', function(){
      if(lbStage) lbStage.classList.remove('is-loading');
      if(lbErr) lbErr.hidden = false;
    });
  }
  function activeThumbIdx(){ var a = root.querySelector('[data-thumb].is-active'); return a ? +a.getAttribute('data-thumb') : 0; }
  function lbShow(){ if(!GAL.length||!lbImg)return; lbIdx=(lbIdx%GAL.length+GAL.length)%GAL.length;
    var next=GAL[lbIdx];
    if(lbErr) lbErr.hidden = true;
    if(lbStage && (lbImg.getAttribute('src')||'').split('?')[0]!==next.split('?')[0]) lbStage.classList.add('is-loading');
    lbImg.src=next; if(lbImg.complete && lbImg.naturalWidth && lbStage) lbStage.classList.remove('is-loading');
    if(lbCount) lbCount.textContent=(lbIdx+1)+' / '+GAL.length;
    preload(GAL[(lbIdx+1)%GAL.length]); preload(GAL[(lbIdx-1+GAL.length)%GAL.length]); }
  function lbOpen(){ if(!lb)return; GAL=buildLbGal(); if(!GAL.length)return;
    GAL.forEach(preload); /* alle Zoom-Bilder (1600) sofort vorwärmen → Blättern ohne Warten */
    /* Startindex = AKTIVER Thumbnail (zuverlässig — Thumbs & Lightbox-Galerie stammen
       aus derselben Medienliste der aktuellen Farbe, Reihenfolge identisch).
       Der frühere URL-Vergleich schlug fehl, weil Bühne (?width=1000, Liquid ?v=…)
       und Galerie (_mSrc+'?width=1600') unterschiedlich gebaut werden → immer Bild 1.
       URL-Vergleich bleibt nur noch als Fallback. */
    var aEl = root.querySelector('[data-thumb].is-active'), i0 = -1;
    if(aEl){ var ai = +aEl.getAttribute('data-thumb'); if(ai >= 0 && ai < GAL.length) i0 = ai; }
    if(i0 < 0){
      var cur=(stage&&stage.src?stage.src.split('?')[0]:'');
      for(var i=0;i<GAL.length;i++){ if(GAL[i].split('?')[0]===cur){ i0=i; break; } }
    }
    lbIdx = i0 < 0 ? 0 : i0;
    lbShow(); lb.hidden=false; document.documentElement.style.overflow='hidden';
    if(!lbRelease) lbRelease = dialogFocus(lb, lb.querySelector('[data-lb-close]')); }
  function lbClose(){ if(!lb)return; lb.hidden=true; document.documentElement.style.overflow='';
    if(lbRelease){ lbRelease(); lbRelease=null; } }
  var zoom = root.querySelector('[data-zoom]'); if(zoom) zoom.addEventListener('click', function(e){ e.stopPropagation(); lbOpen(); });
  if(stage) stage.addEventListener('click', function(e){ if(e.target.closest('button')) return; lbOpen(); });
  var lbPrev=root.querySelector('[data-lb-prev]'), lbNext=root.querySelector('[data-lb-next]'), lbX=root.querySelector('[data-lb-close]');
  if(lbPrev) lbPrev.addEventListener('click', function(e){ e.stopPropagation(); lbIdx--; lbShow(); });
  if(lbNext) lbNext.addEventListener('click', function(e){ e.stopPropagation(); lbIdx++; lbShow(); });
  if(lbX) lbX.addEventListener('click', lbClose);
  /* Nach einem Wisch darf der nachfolgende Klick die Lightbox NICHT schließen. */
  var lbSwiped=false;
  if(lb) lb.addEventListener('click', function(e){ if(lbSwiped) return; if(e.target===lb) lbClose(); });
  /* Wischen (Mobil): horizontal blättern. Vorher gab es im Lightbox GAR KEINE
     Touch-Handler — nur Klick/Tastatur —, deshalb funktionierte das Wischen nicht.
     Nur klar horizontale Gesten (≥40px und deutlicher als vertikal) blättern,
     damit Scrollen/Schließen nicht versehentlich auslöst. */
  if(lb){
    var lsx=null, lsy=null;
    lb.addEventListener('touchstart', function(e){ var t=e.changedTouches[0]; lsx=t.clientX; lsy=t.clientY; lbSwiped=false; }, {passive:true});
    lb.addEventListener('touchend', function(e){
      if(lsx===null) return;
      var t=e.changedTouches[0], dx=t.clientX-lsx, dy=t.clientY-lsy; lsx=null;
      if(Math.abs(dx)<40 || Math.abs(dx)<=Math.abs(dy)) return;
      lbSwiped=true; setTimeout(function(){ lbSwiped=false; }, 400);
      if(dx<0) lbIdx++; else lbIdx--;
      lbShow();
    }, {passive:true});
  }
  document.addEventListener('keydown', function(e){ if(!lb||lb.hidden)return; if(e.key==='Escape')lbClose(); else if(e.key==='ArrowLeft'){lbIdx--;lbShow();} else if(e.key==='ArrowRight'){lbIdx++;lbShow();} });

  /* Titel NIE still abschneiden: passt der Name nicht in die Zeilengrenze, erscheint
     „Ganzen Namen anzeigen“ (aria-expanded). Gemessen nach dem Schrift-Laden und bei
     Größenänderung des Titels — kein Scroll-Handler. */
  (function(){
    var t = root.querySelector('[data-title]'), b = root.querySelector('[data-tmore]');
    if (!t || !b) return;
    function measure(){ if (t.classList.contains('is-open')) return; b.hidden = !(t.scrollHeight > t.clientHeight + 2); }
    b.addEventListener('click', function(){
      var open = !t.classList.contains('is-open');
      t.classList.toggle('is-open', open);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      b.textContent = open ? 'Namen einklappen' : 'Ganzen Namen anzeigen';
      if (!open) measure();
    });
    measure();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    if ('ResizeObserver' in window) { try { new ResizeObserver(measure).observe(t); } catch (e) {} }
  })();

  render(false);
  /* Aktuellen Thumb-Satz (Bühne 1000px) vorwärmen → Navigation ab dann sofort. */
  warmSet([].slice.call(root.querySelectorAll('[data-thumb] img'), 1, 3).map(function(im){ return stageUrl(im.src); }));

  /* „Mehr Bilder"-Indikator am Thumbnail-Streifen: einblenden solange unten noch
     verborgene Kacheln sind; Zähler = Anzahl darunter; ausblenden am Scroll-Ende.
     Klick scrollt ~4 Kacheln weiter. ResizeObserver deckt Varianten-Neurendern ab. */
  (function(){
    var strip = root.querySelector('.r24pd-thumbs');
    var more = root.querySelector('[data-thumbmore]');
    if(!strip || !more) return;
    /* „+N" = verborgene Thumbs des AKTUELLEN Farbsatzes (nicht media.size über alle
       Farben). 5 Kacheln passen sichtbar → hidden = Gesamt − 5. Aktualisiert sich
       per ResizeObserver, wenn das JS die Thumbs bei Farbwechsel neu rendert. */
    function updateMore(){
      var n = strip.querySelectorAll('.r24pd-thumb').length;
      var visible = Math.max(1, Math.floor(strip.clientWidth / 90));
      var hidden = n - visible;
      if(hidden > 0){ more.textContent = '+' + hidden; more.classList.add('is-shown'); }
      else more.classList.remove('is-shown');
    }
    more.addEventListener('click', function(){
      strip.scrollBy({ left: strip.clientWidth - 100, behavior: RM ? 'auto' : 'smooth' });
    });
    if('ResizeObserver' in window){ try{ new ResizeObserver(updateMore).observe(strip); }catch(e){} }
    updateMore();
    setTimeout(updateMore, 500);
  })();

  /* Toter „Mehr lesen"-Handler entfernt: [data-more-desc] wird nirgends mehr
     gerendert (Kurz-Teaser unter dem Titel wurde entfernt). */
})();

/* „Zahlung & Service“: die PayPal-Dienste hängt r24-paypal-later erst nach dem Laden ein.
   Der Bereich erscheint deshalb erst, wenn er Inhalt hat, und seine Kurzzeile nennt genau
   das — nie ein Versprechen für etwas, das nicht drinsteht. */
(function () {
  var svc = document.querySelector('[data-r24pd] [data-r24pd-svc]');
  if (!svc) return;
  var body = svc.querySelector('.r24pd-svc__body'), hint = svc.querySelector('[data-r24pd-svc-hint]');
  function sync() {
    var t = [];
    if (body.querySelector('.r24pp__c')) t.push('Später bezahlen mit PayPal');
    if (body.querySelector('[data-r24fp-open]')) t.push('Zahlungsplanung');
    if (body.querySelector('[data-r24-otto]')) t.push('Auch auf OTTO');
    svc.hidden = !t.length;
    if (hint && hint.textContent !== t.join(' · ')) hint.textContent = t.join(' · ');
  }
  sync();
  try { new MutationObserver(sync).observe(body, { childList: true, subtree: true }); }
  catch (e) { if (window.console) console.warn('[r24pd] Zahlung & Service: Beobachter nicht verfuegbar', e); }
})();

/* ── Kaufleiste (Handoff §11; Runde 2, 21.09.2026: früher Kaufweg am Telefon).
   Sie hat KEIN eigenes Formular und DUPLIZIERT keine Warenkorb-Logik: „In den
   Warenkorb“ klickt den echten Knopf der Kaufbox — gleiches Formular, gleiche Menge,
   native Pflichtfeld-Prüfung (auch „Zuschnitt-Länge“), gleiche Sperre gegen
   Doppel-Absenden (render() → atcState() → data-state, Ereignis „r24pd:state“).

   KNOPF — was er tut, hängt vom Produkt und von der Auswahl ab, nie von der Scroll-Lage:
   · Produkt mit Auswahl (Farbe/Maß/…, mehr als eine Variante) oder mit Zuschnitt:
     „Auswahl & Kauf“ springt zur Kaufauswahl (#r24pd-kauf, ohne Animation bei
     reduzierter Bewegung) und setzt den Fokus in die erste Optionsgruppe. Nie landet
     eine ungesehene Vorauswahl im Warenkorb (Entscheid A6). Erst wenn in der Kaufbox
     selbst gewählt wurde (Klick auf eine Option; bei Zuschnitt: gültige Länge), wird
     er zu „In den Warenkorb“. Die Aktion folgt immer der angezeigten Beschriftung.
   · Produkt ohne Auswahl: „In den Warenkorb“ = echter Knopf.
   · Ausverkauft / „Nicht verfügbar“ / Anfrage läuft: gespiegelt vom echten Knopf.

   WANN SIE ERSCHEINT — nie, solange die echte Kaufzeile im Bild ist; sonst:
   · bis 900 px (einspaltig), sobald Titel und Kurz-Preiszeile oben hinaus sind.
     Gemessen 390×844: „In den Warenkorb“ lag auf y≈997 (Velmora) bzw. y≈1532
     (Arbeitsplatte: 12 Längen + Zuschnitt) — vorher kam die Leiste erst DANACH.
   · breiter, wenn die Kaufzeile oben hinaus ist (die Kaufbox steht neben dem Bild).
   Drei Beobachter statt Scroll-Handler: Titelzeile, Kaufzeile und die Kaufzeile mit
   weit nach oben verlängertem Rahmen — er meldet jedes Überqueren der Bildschirm-
   Unterkante, auch bei Sprüngen (Anker, Pos1/Ende). Jede Meldung liest die Lage neu.

   Am Telefon ersetzt sie die Tab-Leiste (html.r24-cta-on) statt sie zu überdecken,
   und meldet jeden Wechsel an R24Float (sie steht dort in BODENLEISTEN).
   SCHLIESSEN: das × gilt für DIESES Produkt in der Sitzung (bis 23.09.2026 für die ganze
   Sitzung — ein einziger Fehltipp neben „In den Warenkorb“ nahm den Kaufknopf dann auf
   jeder weiteren Produktseite weg). */
(function () {
  var root = document.querySelector('[data-r24pd]');
  if (!root || document.querySelector('[data-r24pd-sticky]')) return;
  var atc = root.querySelector('[data-atc]');
  if (!atc) return;
  var ZU = 'r24pd-cta-zu', PID = root.getAttribute('data-pid') || '1';
  /* Gesperrter Speicher (Privatmodus) wirft — dann gilt „nicht geschlossen“. */
  try { if (sessionStorage.getItem(ZU) === PID) return; } catch (e) { /* weiter ohne Sitzungsspeicher */ }

  var form = root.querySelector('#r24pd-form');
  /* Optionsgruppen mit echter Wahl (≥ 2 Werte) und Zuschnitt-Feld. Eine Gruppe mit nur
     EINEM Wert (z. B. eine einzige Farbe) ist keine Wahl — sie liess die Leiste sonst auf
     „Auswahl & Kauf“ stehen bzw. schaltete nach einem Tipp darauf in den Kaufmodus, bevor
     die eigentliche Wahl (Breite) gesehen war (Review R3). „Gewählt“ = ein aktiver Tipp in
     einer ECHTEN Gruppe (die Kaufbox ist dann im Blick) — nie eine unsichtbar vorgewählte Variante. */
  var multi = [];
  if (form) [].forEach.call(form.querySelectorAll('[role="group"][data-optname]'), function (g) {
    if (g.querySelectorAll('[data-opt]').length > 1) multi.push(g);
  });
  var gruppe = multi[0] || null;
  var cutIn = form && form.querySelector('[data-r24-cut-in]');
  var mussWaehlen = !!(gruppe || cutIn);
  var gewaehlt = false;
  var EINSPALTIG = window.matchMedia ? window.matchMedia('(max-width:900px)') : null;

  var bar = document.createElement('div');
  bar.className = 'r24pd-sticky';
  bar.setAttribute('data-r24pd-sticky', '');
  bar.setAttribute('role', 'region');
  bar.setAttribute('aria-label', 'Kaufleiste');
  bar.innerHTML =
    '<div class="r24pd-sticky__in">'
  +   '<span class="r24pd-sticky__img"></span>'
  +   '<span class="r24pd-sticky__tx"><b class="r24pd-sticky__t"></b><span class="r24pd-sticky__p"></span></span>'
  +   '<button type="button" class="r24pd-sticky__btn" data-mode="kauf">'
  +     '<svg data-ico="kauf" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2.5 3.5h2.3l2.3 11.1a1.5 1.5 0 0 0 1.5 1.2h8.2a1.5 1.5 0 0 0 1.5-1.2L20 7.5H6"/></svg>'
  +     '<svg data-ico="wahl" hidden viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" aria-hidden="true"><path d="M4 7h9M17 7h3M4 17h3M11 17h9"/><circle cx="15" cy="7" r="2"/><circle cx="9" cy="17" r="2"/></svg>'
  +     '<span data-sticky-label>In den Warenkorb</span></button>'
  +   '<button type="button" class="r24pd-sticky__x" aria-label="Kaufleiste schließen">'
  +     '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>'
  +   '</button>'
  + '</div>';
  document.body.appendChild(bar);

  var elT = bar.querySelector('.r24pd-sticky__t');
  var elP = bar.querySelector('.r24pd-sticky__p');
  var elI = bar.querySelector('.r24pd-sticky__img');
  var btn = bar.querySelector('.r24pd-sticky__btn');
  var elL = bar.querySelector('[data-sticky-label]');
  var icoKauf = bar.querySelector('[data-ico="kauf"]'), icoWahl = bar.querySelector('[data-ico="wahl"]');

  /* kauf · wahl · aus · busy — aus dem Zustand des echten Knopfs (data-state). */
  function modus() {
    var st = atc.getAttribute('data-state') || (atc.hasAttribute('disabled') ? 'aus' : 'ok');
    if (st === 'busy') return 'busy';
    if (mussWaehlen && (st !== 'ok' || !(cutIn ? cutIn.validity.valid : gewaehlt))) {
      return root.getAttribute('data-available') === 'false' ? 'aus' : 'wahl';
    }
    return st === 'ok' ? 'kauf' : 'aus';
  }
  function sync() {
    var h1 = root.querySelector('h1');
    if (h1) elT.textContent = h1.textContent.trim();
    var pr = root.querySelector('[data-now]');
    if (pr) elP.textContent = pr.textContent.trim();
    var im = root.querySelector('.r24pd-stage img');
    /* Anführungszeichen in der URL maskieren, sonst bricht der style-Wert auf. */
    if (im && im.getAttribute('src')) elI.style.backgroundImage = 'url("' + im.src.replace(/["\\]/g, '\\$&') + '")';
    var m = modus();
    btn.setAttribute('data-mode', m);
    var t = m === 'wahl' ? 'Auswahl & Kauf' : m === 'aus' ? 'Ausverkauft' : 'In den Warenkorb';
    if (elL.textContent !== t) elL.textContent = t;
    if (m === 'wahl') { icoKauf.setAttribute('hidden', ''); icoWahl.removeAttribute('hidden'); }
    else { icoWahl.setAttribute('hidden', ''); icoKauf.removeAttribute('hidden'); }
    if (m === 'aus') btn.setAttribute('disabled', 'disabled'); else btn.removeAttribute('disabled');
    /* Während der Anfrage fokussierbar bleiben (kein Fokusverlust), aber gesperrt. */
    if (m === 'busy') { btn.setAttribute('aria-disabled', 'true'); btn.setAttribute('aria-busy', 'true'); }
    else { btn.removeAttribute('aria-disabled'); btn.removeAttribute('aria-busy'); }
  }
  sync();
  /* Gebündelt auf EIN Bild pro Frame — render() und Eingaben melden sich oft kurz
     hintereinander (Klick auf eine Option = Klick + r24pd:state). */
  var syncQueued = false;
  function syncSoon() {
    if (syncQueued) return;
    syncQueued = true;
    requestAnimationFrame(function () { syncQueued = false; sync(); });
  }
  root.addEventListener('r24pd:state', syncSoon);
  if (form) {
    /* Nach dem Zeitgeber des Zuschnitt-Felds (es prüft die Länge nach einem
       Bereichswechsel per setTimeout 0) — sonst läse die Leiste die alte Gültigkeit. */
    form.addEventListener('click', function (e) {
      var o = e.target && e.target.closest && e.target.closest('[data-opt]');
      if (!o) return;
      var g = o.closest('[role="group"][data-optname]');
      if (g && multi.indexOf(g) > -1) gewaehlt = true;
      setTimeout(syncSoon, 0);
    });
    form.addEventListener('input', syncSoon);
    form.addEventListener('change', syncSoon);
  }

  /* „Auswahl & Kauf“: zur Kaufauswahl, Fokus auf die gewählte (sonst erste) Option der
     ersten Gruppe — ohne zweiten Sprung (preventScroll), der Bildlauf macht das. */
  function zurAuswahl() {
    var ziel = document.getElementById('r24pd-kauf') || form;
    var ruhig = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    if (ziel) ziel.scrollIntoView({ block: 'start', behavior: ruhig ? 'auto' : 'smooth' });
    var f = gruppe && (gruppe.querySelector('[aria-pressed="true"]') || gruppe.querySelector('[data-opt]'));
    if (!f) f = cutIn;
    if (f) f.focus({ preventScroll: true });
  }
  btn.addEventListener('click', function () {
    var m = btn.getAttribute('data-mode');
    if (m === 'wahl') zurAuswahl();
    else if (m === 'kauf') atc.click();
  });

  var shown = false, zu = false;
  function setShown(on) {
    on = on && !zu;
    if (on === shown) return;
    shown = on;
    /* Faehrt die Leiste weg, waehrend ihr Knopf den Fokus hat, fiele er auf <body> (Review R3). */
    if (!on && bar.contains(document.activeElement) && atc && atc.focus) atc.focus({ preventScroll: true });
    bar.classList.toggle('is-on', on);
    document.documentElement.classList.toggle('r24-cta-on', on);
    /* Schwebende Knöpfe (R24Float) müssen die neue Bodenleiste kennen — einmal
       sofort, einmal nach dem Einfahren, wenn die Endlage steht. */
    if (window.R24Float) window.R24Float.refresh();
  }
  bar.addEventListener('transitionend', function (e) {
    if (e.target === bar && e.propertyName === 'transform' && window.R24Float) window.R24Float.refresh();
  });
  bar.querySelector('.r24pd-sticky__x').addEventListener('click', function () {
    zu = true;
    try { sessionStorage.setItem(ZU, PID); } catch (e) { /* ohne Speicher gilt es nur fuer diese Seite */ }
    setShown(false);
  });

  var titel = root.querySelector('.r24pd-titlerow');
  var zeile = atc.closest('.r24pd-buy') || atc;
  if (!('IntersectionObserver' in window)) return;
  function pruefen() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var z = zeile.getBoundingClientRect();
    var kaufImBild = z.bottom > 0 && z.top < vh;
    var frueh = !!(EINSPALTIG && EINSPALTIG.matches && titel && titel.getBoundingClientRect().bottom <= 0);
    setShown(!kaufImBild && (z.bottom <= 0 || frueh));
  }
  new IntersectionObserver(pruefen).observe(zeile);
  new IntersectionObserver(pruefen, { rootMargin: '100000px 0px 0px 0px' }).observe(zeile);
  if (titel) new IntersectionObserver(pruefen).observe(titel);
  if (EINSPALTIG) {
    if (EINSPALTIG.addEventListener) EINSPALTIG.addEventListener('change', pruefen);
    else if (EINSPALTIG.addListener) EINSPALTIG.addListener(pruefen);
  }
})();

/* Galerie: Prev/Next + Zähler „n / N" (Handoff §3).
   Die Pfeile führen KEINE eigene Bildlogik — sie klicken schlicht den nächsten
   bzw. vorherigen Thumbnail. Damit gilt weiterhin exakt die vorhandene Logik
   (Farbsätze, Vorwärmen, aktiver Zustand); es entsteht kein zweiter Zustand. */
(function () {
  var root = document.querySelector('[data-r24pd]');
  var stage = root && root.querySelector('.r24pd-stage');
  if (!root || !stage || stage.querySelector('.r24pd-nav')) return;

  function thumbs() { return [].slice.call(root.querySelectorAll('.r24pd-thumb')); }

  function mk(dir, path, cls) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'r24pd-nav r24pd-nav--' + cls;
    b.setAttribute('aria-label', dir);
    b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.3" stroke-linecap="round" stroke-linejoin="round"><path d="' + path + '"/></svg>';
    return b;
  }
  var prev = mk('Vorheriges Bild', 'M15 6l-6 6 6 6', 'prev');
  var next = mk('Nächstes Bild', 'M9 6l6 6-6 6', 'next');
  var idx = document.createElement('span');
  idx.className = 'r24pd-idx';
  stage.appendChild(prev); stage.appendChild(next); stage.appendChild(idx);

  function activeIndex(list) {
    for (var i = 0; i < list.length; i++) if (list[i].classList.contains('is-active')) return i;
    return 0;
  }
  function refresh() {
    var list = thumbs();
    var show = list.length > 1;
    prev.style.display = next.style.display = show ? '' : 'none';
    idx.style.display = show ? '' : 'none';
    if (show) idx.textContent = (activeIndex(list) + 1) + ' / ' + list.length;
  }
  function go(step) {
    var list = thumbs();
    if (list.length < 2) return;
    var n = (activeIndex(list) + step + list.length) % list.length;   /* zyklisch */
    list[n].click();
    setTimeout(refresh, 60);
  }
  prev.addEventListener('click', function (e) { e.preventDefault(); go(-1); });
  next.addEventListener('click', function (e) { e.preventDefault(); go(1); });
  root.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.r24pd-thumb')) setTimeout(refresh, 60);
  }, true);
  /* Farbwechsel rendert die Thumbs neu → Zähler nachziehen. NUR die Kachelreihe
     beobachten: fiele der Beobachter auf `root` zurück (Produkt ohne Medien),
     würde `refresh()` mit seinem eigenen textContent-Schreiben sich selbst
     auslösen. Zusätzlich auf einen Frame gebündelt. */
  var refreshQueued = false;
  function refreshSoon() {
    if (refreshQueued) return;
    refreshQueued = true;
    requestAnimationFrame(function () { refreshQueued = false; refresh(); });
  }
  var strip = root.querySelector('.r24pd-thumbs');
  if (strip) { try { new MutationObserver(refreshSoon).observe(strip, { childList: true }); } catch (e) {} }
  refresh();
})();
